import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import moment from '../../../../helpers/moment'

import { DayFilter } from './dayFilter'
import { ShiftRow } from './shiftRow'
import ShiftEditRow from './shiftEditRow'
import { gotoEditMode, loadShiftsAsync, shiftOnChange, saveChangedShiftsAsync, addShift } from '../../../../actions/shifts'
import Loader from '../../../../components/loader'
import Error from '../../../../components/alerts/error'

import './styles.css'

export class Shifts extends React.Component {
  componentDidMount() {
    this.props.loadShiftsAsync(this.props.poolId)
  }

  activeShift(shifts, currentTime) {
    currentTime = currentTime || new Date()
    let currentShiftStart

    let sortedShifts = shifts.slice().sort((a, b) => new Date(a.start) - new Date(b.start))
    sortedShifts.forEach(s => {
      if (currentTime > new Date(s.start)) {
        currentShiftStart = s.start
      }
    })
    return currentShiftStart
  }

  disableSave(){
    return this.props.shifts.filter(s=>s.inValid).length > 0
  }

  render() {
    const { shifts, editMode, gotoEditMode, shiftOnChange, poolId,
      saveChangedShiftsAsync, addShift, isLoading, error } = this.props
    const activeDate = this.props.activeDate || new Date().toISOString()

    let currentShiftStart = this.activeShift(shifts)
    let shiftsToday = shifts.filter(i => moment(i.start).isSame(activeDate, 'day'))
    let selectedTimes = shiftsToday.map(s => s.start)

    let rows = shiftsToday.map((item, index) => editMode ?
      <ShiftEditRow key={index} item={item} onChange={shiftOnChange} currentShift={item.start === currentShiftStart} selectedTimes={selectedTimes} />
      : <ShiftRow key={index} start={item.start} activeDrivers={item.activeDrivers} currentShift={item.start === currentShiftStart} />
    )

    if (error !== undefined) {
      rows = <tr><td colSpan={3}><Error title="Error loading shifts" body={error} /></td></tr>
    }
    else if (isLoading) {
      rows = <tr><td colSpan={3}><Loader /></td></tr>
    }

    let headerButtons

    if (editMode) {
      headerButtons = <div>
        <button id="CancelShifts" className="btn btn-sm btn-secondary margin-right-5" onClick={() => gotoEditMode(false)}>Cancel</button>
        <button id="SaveShifts" className="btn btn-sm btn-success" onClick={() => saveChangedShiftsAsync(poolId, shifts)} disabled={this.disableSave()}>Save</button>
      </div>
    }
    else {
      headerButtons = <button id="EditShifts" className="btn btn-sm btn-primary"
        onClick={() => gotoEditMode(true)}>Edit</button>
    }

    return <div>
      <div className="row">
        <div className="col-xl-8 col-lg-11" style={{ marginTop: 10, marginBottom: 5 }}>
          <DayFilter poolId={poolId} activeDate={activeDate} />
        </div>
        <div className="col-xl col-lg shift-buttons">
          {headerButtons}
        </div>
      </div>

      <div className="row">
        <div className="col-lg-6 col-sm-12">
          <table className={"table table-striped table-hover" + (editMode ? " shift-row-sm" : "")}>
            <thead>
              <tr>
                <th>Start</th>
                <th>Active Drivers</th>
                <th className="shift-th-edit">{editMode && <button id="AddShift" className="btn btn-success btn-sm shift-button-tiny" onClick={() => addShift(activeDate)}>+</button>}</th>
              </tr>
            </thead>
            <tbody>
              {rows}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  }
}

Shifts.propTypes = {
  poolId: PropTypes.string.isRequired,
  shifts: PropTypes.array.isRequired,
  editMode: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  error: PropTypes.string,
  gotoEditMode: PropTypes.func.isRequired,
  loadShiftsAsync: PropTypes.func.isRequired,
  shiftOnChange: PropTypes.func.isRequired,
  saveChangedShiftsAsync: PropTypes.func.isRequired,
  addShift: PropTypes.func.isRequired,
  activeDate: PropTypes.string
}

const mapStateToProps = (state, props) => {
  return {
    ...props,
    shifts: state.shifts.present.shifts,
    isLoading: state.shifts.present.isLoading,
    editMode: state.shifts.present.shiftsEditMode,
    error: state.shifts.present.error,
    activeDate: props.activeDate
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  gotoEditMode,
  loadShiftsAsync,
  shiftOnChange,
  saveChangedShiftsAsync,
  addShift
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Shifts)



// WEBPACK FOOTER //
// ./src/containers/pools/details/shifts/index.js